<div class="ui basic segment">
  <div style="margin: -20px -30px" class="ui vertical basic segment">
    <div *ngIf="success || error">
      <esl-message-toast
        [(message)]="success"
        [messageType]="'success'"
      ></esl-message-toast>
      <esl-message-toast [(message)]="error"></esl-message-toast>
    </div>

    <app-advanced-search-filter
      (onDisplayRows)="displayRecords($event)"
      (onSearch)="searchRecords($event)"
      [hasAdvancedSearch]="true"
      [headers]="headers"
      [headerFilters]="headerFilters"
      [hasFilters]="true"
      (onSort)="sortRecords($event)"
      [searchFilters]="searchFilter"
      (advancedSearch)="advancedSearch($event)"
      (cancelAd)="cancelAd()"
    ></app-advanced-search-filter>
  </div>
  <div
    style="margin: -10px -30px"
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
  >
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="15%">IP Address</div>
      <div fxFlex="15%">Agent Name</div>
      <div fxFlex="40%">Username</div>
      <div fxFlex="35%">Date</div>
      <div fxFlex="10%"></div>
      <div fxFlex="10%"></div>
    </div>
    <ng-container *ngFor="let user of users">
      <div
        class="ui segment"
        appMargin
        marginB="3"
        fxLayout="row"
        fxLayoutGap="10px"
        fxLayoutAlign="start stretch"
      >
        <div fxFlex="15%">{{ user?.metadata?.lastIp || "--" }}</div>
        <div fxFlex="15%">{{ user?.metadata?.lastAgent || "---" }}</div>
        <div fxFlex="40%">{{ user?.user?.username }}</div>
        <div fxFlex="35%">
          {{ user?.user?.lastLoginDate | date: "medium" }}
        </div>
        <div fxFlex="10%">
          <div (click)="blacklistIp(user)" class="ui circular button">
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8.84648 18C6.76148 17.475 5.04008 16.2786 3.68228 14.4108C2.32448 12.543 1.64588 10.4694 1.64648 8.19V2.7L8.84648 0L16.0465 2.7V8.19C16.0465 10.47 15.3679 12.5439 14.0107 14.4117C12.6535 16.2795 10.9321 17.4756 8.84648 18ZM8.84648 16.11C10.4065 15.615 11.6965 14.625 12.7165 13.14C13.7365 11.655 14.2465 10.005 14.2465 8.19V3.9375L8.84648 1.9125L3.44648 3.9375V8.19C3.44648 10.005 3.95648 11.655 4.97648 13.14C5.99648 14.625 7.28648 15.615 8.84648 16.11Z"
                fill="#FF2C2C"
              />
              <path
                d="M8.28964 6.47567C8.22214 6.59809 8.16107 6.72365 8.10964 6.85234L8.60143 7.33261C8.73321 6.98104 8.91 6.65145 9.12536 6.34697C9.39214 6.72365 9.6075 7.14427 9.73929 7.59315H8.86821L9.51107 8.22094H9.8775C9.89679 8.34964 9.90964 8.48462 9.91929 8.61959L10.5525 9.23797C10.5621 9.10928 10.5718 8.98058 10.5718 8.84874C10.5718 8.63529 10.5525 8.42812 10.5268 8.22094H11.6132C11.6646 8.42184 11.6968 8.63215 11.6968 8.84874C11.6968 9.06533 11.6646 9.27564 11.6132 9.47654H10.7968L11.8575 10.5061C12.1596 10.0259 12.3396 9.4577 12.3396 8.84874C12.3396 7.1223 10.8932 5.70975 9.12536 5.70975C8.50179 5.70975 7.92 5.88554 7.42821 6.1806L7.8975 6.65145C8.02286 6.57925 8.16107 6.51961 8.28964 6.47567ZM11.3496 7.59315H10.4014C10.3008 7.20437 10.1519 6.82908 9.95786 6.47567C10.5493 6.67342 11.0411 7.07207 11.3496 7.59315ZM6.03643 5.625L5.625 6.02365L6.57321 6.94965C6.1438 7.4939 5.91097 8.16167 5.91107 8.84874C5.91107 10.5752 7.3575 11.9877 9.12536 11.9877C9.85821 11.9877 10.53 11.746 11.0732 11.3442L11.9668 12.2169L12.375 11.8182L6.03643 5.625ZM7.03607 7.39539L7.23214 7.59315H6.90107C6.93964 7.52409 6.98464 7.46131 7.03607 7.39539ZM6.6375 9.47654C6.58607 9.27564 6.55393 9.06533 6.55393 8.84874C6.55393 8.63215 6.58607 8.42184 6.6375 8.22094H7.72393C7.69821 8.42812 7.67893 8.63529 7.67893 8.84874C7.67893 9.06219 7.69821 9.26936 7.72393 9.47654H6.6375ZM6.90107 10.1043H7.83964C7.95214 10.4967 8.09679 10.8734 8.28964 11.2218C7.7042 11.0246 7.2112 10.6278 6.90107 10.1043ZM8.32179 8.84874C8.32179 8.78596 8.32179 8.72632 8.33143 8.66668L9.16071 9.47654H8.37321C8.34107 9.26936 8.32179 9.06219 8.32179 8.84874ZM9.12536 11.3474C8.85857 10.9707 8.64321 10.5532 8.51143 10.1043H9.73929C9.6075 10.5532 9.39214 10.9707 9.12536 11.3474ZM9.95786 11.2218C10.0768 11.0084 10.1732 10.7792 10.2504 10.5469L10.6104 10.8891C10.4111 11.0303 10.1925 11.1433 9.95786 11.2218Z"
                fill="#FF2C2C"
              />
            </svg>
          </div>
        </div>
        <div fxFlex="10%">
          <div (click)="viewUser(user)" class="ui circular button">
            <i class="eye icon"></i>
          </div>
        </div>
        <!-- <div fxFlex  class="text-right">
                <button class="ui circular tiny button" (click)="onDelete.emit(user)"><i class="trash icon"></i></button>
                <a class="ui circular tiny button" routerLink="/admin/setting/user/detail/{{user.id}}"><i class="eye icon"></i></a>
            </div> -->
      </div>
    </ng-container>
    <app-no-record-found
      *ngIf="users && users.length < 1"
    ></app-no-record-found>

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon small button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
